
import CarServiceReport from  '@/components/Reports/CarServiceReport'
import TransactionConsumableReport from  '@/components/Reports/TransactionConsumableReport'
import TransactionPartReport from  '@/components/Reports/TransactionPartReport'
import WithdrawReport from  '@/components/Reports/WithdrawReport'
import WithdrawSummaryReport from  '@/components/Reports/WithdrawSummaryReport'
import JobImageReport from  '@/components/Reports/JobImageReport'
import ControllerReport from  '@/components/Reports/ControllerReport'

export default [
      {
        path: '/carServiceReport/:pageCode',
        name: 'carServiceReport',
        props: true,
        component: CarServiceReport
      },
      {
        path: '/transactionConsumableReport/:pageCode',
        name: 'transactionConsumableReport',
        props: true,
        component: TransactionConsumableReport
      },
      {
        path: '/transactionPartReport/:pageCode',
        name: 'transactionPartReport',
        props: true,
        component: TransactionPartReport
      },
      {
        path: '/withdrawReport/:pageCode',
        name: 'withdrawReport',
        props: true,
        component: WithdrawReport
      },
      {
        path: '/withdrawSummaryReport/:pageCode',
        name: 'withdrawSummaryReport',
        props: true,
        component: WithdrawSummaryReport
      },
      {
        path: '/jobImageReport/:pageCode',
        name: 'jobImageReport',
        props: true,
        component: JobImageReport
      },
      {
        path: '/controllerReport/:pageCode',
        name: 'controllerReport',
        props: true,
        component: ControllerReport
      }
    
]